import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText,  DialogActions, Button, Box, Typography } from '@mui/material'
import QRImage from "../../../../../../images/QR--para-app.png"
import downloadImage from "../../../../../../images/Download-app.png"
import './tour-modal.scss'

type Props = {
    open: boolean;
    onClose: () => void; 
    remindLater: () => void;
    isMobile?: boolean;
}

const TourModal:React.FC<Props> = ({ open, onClose, remindLater, isMobile })=> {
    return(
        <Dialog 
            open={open} 
            onClose={onClose}
            className={`tour-modal-dialog ${isMobile ? 'is-mobile' : ''}`}
            sx={{height:'100%',}}
        > 
            {isMobile? (
                <DialogTitle className='tour-modal-title'>Saber onde a sua equipe está é essencial para uma gestão estratégica </DialogTitle>
            ):(
                <DialogTitle className='tour-modal-title'>Quer ver sua localização aparecendo no mapa?</DialogTitle>
            )}
            
            <DialogContent className='tour-modal-content'>
                <Box 
                    component="img"
                    src={downloadImage}
                    className='content-image-main'
                >
                </Box>
                <Box className='content-info-wrapper'>
                    <Box>
                    {isMobile ? (
                        <Typography className='info-text'>
                            Veja sua localização aqui no mapa ao acessar o aplicativo! Basta compartilhar sua localização ou iniciar ou finalizar uma atividade. 
                        </Typography>
                    ):(
                        <Typography className='info-text'>
                            No aplicativo você pode compartilhar sua localização ou iniciar ou finalizar uma atividade. Assim o seu endereço será exibido aqui no mapa.
                        </Typography>
                    )}
                    </Box>
                    {!isMobile && 
                    <Box className="qrcode-section">
                        <Box className="qrcode-text-wrapper">
                            <Box component="span">
                                Atalho rápido: 
                            </Box>
                            <Box >
                                Aponte a câmera do seu celular para o QR Code abaixo para acessar o aplicativo.
                            </Box>
                        </Box>
                        <Box
                            component="img"
                            src={QRImage}
                            alt="QR Code"
                            className="qrcode-image"
                        >
                        </Box>
                    </Box>
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                {isMobile ? (
                <Box>
                <Button 
                    component="a"
                    href="https://produttivo.app.link/BrChcSGEMAb"
                    variant="contained"
                    fullWidth
                >
                    Abrir Aplicativo agora
                </Button>
                 <Button 
                    onClick={remindLater} 
                    variant="outlined"
                    fullWidth
                    className='remind-later-mobile'
                >
                    Me lembre depois
                </Button>
                </Box>
                ) : (
                <Button 
                    onClick={remindLater} 
                    variant="outlined"
                >
                    Me lembre depois
                </Button>
                )}  
            </DialogActions>
        </Dialog>
    )
}

export default TourModal;